import Axios from '../../utils/union-axios'

/**
 * 查询当前用户私桩共享信息
 */
export function querySharePileInfo() {
  return Axios.get(`/web-h5/charge/private-pile/share/querySharePileInfo`)
}

/**
 * 查询当前用户家充共享申请状态及数据
 */
export function queryShareApplyInfo(data) {
  return Axios.post(`/web-h5/charge/private-pile/share/queryShareApplyInfo`, data)
}

// /**
//  * 桩主私桩共享收益数据汇总（1.2弃用）
//  */
// export function getIncomeTotal(data) {
//   return Axios.post(`/web-h5/charge/privateOrder/orderStatistics`, data)
// }

// /**
//  * 桩主私桩共享收益数据订单列表（1.2弃用）
//  */
// export function getIncomeList(data) {
//   return Axios.post(`/web-h5/charge/privateOrder/orderListByStation`, data)
// }

/**
 * 私桩共享收益统计
 */
export function getIncomeTotal(data) {
  return Axios.post(`/web-h5/charge/privateOrder/incomeStatistics`, data)
}

/**
 * 私桩共享收益列表
 */
export function getIncomeList(data) {
  return Axios.post(`/web-h5/charge/privateOrder/incomeListByStation`, data)
}

/**
 * 根据桩编号换取用户站点信息
 */
export function getSharingStationInfo(data) {
  return Axios.post(`/web-h5/charge/private-pile/share/queryShareStationInfo`, data)
}

/**
 * 共享家桩审批
 */
export function useShareApplyApproval(data) {
  return Axios.post(`/web-h5/charge/private-pile/share/useShareApplyApproval`, data)
}

/**
 * 审批拒绝原因枚举
 */
export function applyUseRefuseReasonEnum() {
  return Axios.get(`/web-h5/charge/private-pile/share/applyUseRefuseReasonEnum`)
}

/**
 * 查询私桩使用申请记录
 */
export function queryUseApply(data) {
  return Axios.post(`/web-h5/charge/private-pile/share/queryUseApply`, data)
}

/**
 * 查询私桩使用申请中数量
 */
export function queryUseApplyingNo(data) {
  return Axios.post(`/web-h5/charge/private-pile/share/queryUseApplyingNo`, data)
}

/**
 * 查询私桩共享用户信息
 */
export function queryShareUserRelation(data) {
  return Axios.post(`/web-h5/charge/private-pile/share/queryShareUserRelation`, data)
}

/**
 * 移除私桩共享用户
 */
export function removeShareUserRelation(data) {
  return Axios.post(`/web-h5/charge/private-pile/share/removeShareUserRelation`, data)
}

/**
 * 移除私桩共享原因枚举
 */
export function getRemoveShareUserReasonEnum() {
  return Axios.get(`/web-h5/charge/private-pile/share/removeShareUserReasonEnum`)
}

/**
 * 关闭私桩共享原因枚举
 */
export function getCloseReasonEnum() {
  return Axios.get(`/web-h5/charge/private-pile/share/closeReasonEnum`)
}

/**
 * 关闭私桩共享
 */
export function closeShare(data) {
  return Axios.post(`/web-h5/charge/private-pile/share/closeShare`, data)
}

/**
 * 获取站点详情数据
 */
export function queryStationDtl(data) {
  return Axios.post(`/web-h5/charge/privateStation/queryStationDtl`, data)
}

/**
 * 获取桩状态数据
 */
export function getPileStatus(data) {
  return Axios.post(`/web-h5/charge/private-pile/share/pileStatus`, data)
}

/**
 * 获取当前用户在当前站点未完成订单数据
 */
export function getUnfinishedOrder(data) {
  return Axios.post(`/web-h5/charge/privateOrder/getUnfinishedOrder`, data)
}

/**
 * 获取用户信息
 */
export function getUserInfo(data) {
  return Axios.post(`/web-h5/charge/privateStation/share/cardManage/getUserInfo`, data)
}

/**
 * 待提现总金额
 */
export function getWaitWithdrawAmount(data) {
  return Axios.post(`/web-h5/charge/privateStation/share/withdrawManage/getWaitWithdrawAmount`, data)
}

/**
 * 发起提现
 */
export function applyWithdraw(data) {
  return Axios.post(`/web-h5/charge/privateStation/share/withdrawManage/applyWithdraw`, data)
}

/**
 * 获取提现汇总信息
 */
export function getWithdrawSummary(data) {
  return Axios.post(`/web-h5/charge/privateStation/share/withdrawManage/getWithdrawSummary`, data)
}

/**
 * 获取提现记录
 */
export function getWithdrawRecord(data) {
  return Axios.post(`/web-h5/charge/privateStation/share/withdrawManage/getWithdrawRecord`, data)
}

/**
 * 绑卡
 */
export function bindCard(data) {
  return Axios.post(`/web-h5/charge/privateStation/share/cardManage/bindCard`, data)
}


/**
 * 开户绑卡
 */
export function openAccountBindCard(data) {
  return Axios.post(`/web-h5/charge/privateStation/share/cardManage/openAccountBindCard`, data)
}

/**
 * 解绑银行卡
 */
export function unbindCard(data) {
  return Axios.post(`/web-h5/charge/privateStation/share/cardManage/unbindCard`, data)
}


/**
 * 提现详情
 */
export function getWithdrawDetail(data) {
  return Axios.post(`/web-h5/charge/privateStation/share/withdrawManage/getWithdrawDetail`, data)
}

/**
 * 私桩订单详情
 */
export function incomeDetail(data) {
  return Axios.post(`/web-h5/charge/privateOrder/incomeDetail`, data)
}

/**
 * 私桩订单详情中的价格详情
 */
export function getOrderBillingMsg(data: {custId: string, orderNo: string}) {
  return Axios.post(`/web-h5/charge/privateOrder/orderBillingMsg`, data)
}

/**
 * 修改是否开启申请免审核
 * isUseApplyAutoAudit "是否开启申请使用免审核。0-否，1-是"
 * stationId 站点ID
 */
export function modifyUseApplyAutoAudit(data: {stationId: string, isUseApplyAutoAudit: number}  ) {
  return Axios.post(`/web-h5/charge/private-pile/share/modifyUseApplyAutoAudit`, data)
}

/**
 * 查询私桩共享特征诊断信息
 */
/**
 * Queries feature diagnosis for private pile sharing.
 *
 * @param data - The request payload containing query parameters.
 * @returns A promise resolving to an object with the following properties:
 * - type: number - 诊断类型。1-共享收益丢失风险，2-找桩指引录入提示，3-定价策略优化建议
 * - diagnosisMsg: string - 诊断文案
 */
export function queryFeatureDiagnosis(data) {
  return Axios.post(`/web-h5/charge/private-pile/share/queryFeatureDiagnosis`, data)
}